import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 * Motor last search legacy params
 */
export default class LastAdsSearchLegacyParamsMapper extends Mapper {
  /**
   * @param {Object} deps
   * @param {Array} deps.arrBodyType
   * @param {String} deps.FuelTypeId
   * @param {String} deps.MaxKms
   * @param {String} deps.MinKms
   * @param {String} deps.ModelId
   * @param {String} deps.MakeId
   * @param {String} deps.MaxPrice
   * @param {String} deps.ProvinceId
   * @param {String} deps.MaxYear
   * @param {String} deps.MinYear
   * @param {String} deps.KeyWords
   * @param {Number} deps.ContractId
   * @param {Boolean} deps.Financed
   * @param {String} deps.MinPrice
   * @param {String} deps.Model
   * @param {Number} deps.OfferType
   * @param {String} deps.PowerHpFrom
   * @param {Number} deps.PowerHpTo
   * @param {String} deps.Section1Id
   * @param {Number} deps.Section2Id
   * @param {Number} deps.Section3Id
   * @param {String} deps.SellerTypeId
   * @param {String} deps.TransmissionTypeId
   * @param {String} deps.Version
   * @param {Boolean} deps.WithWarranty
   */
  constructor({
    arrBodyType,
    FuelTypeId,
    MaxKms,
    MinKms,
    ModelId,
    MakeId,
    MaxPrice,
    ProvinceId,
    MaxYear,
    MinYear,
    KeyWords,
    ContractId,
    Financed,
    MinPrice,
    Model,
    OfferType,
    PowerHpFrom,
    PowerHpTo,
    Section1Id,
    Section2Id,
    Section3Id,
    SellerTypeId,
    TransmissionTypeId,
    Version,
    WithWarranty
  } = {}) {
    super({
      arrBodyType,
      FuelTypeId,
      MaxKms,
      MinKms,
      ModelId,
      MakeId,
      MaxPrice,
      ProvinceId,
      MaxYear,
      MinYear,
      KeyWords,
      ContractId,
      Financed,
      MinPrice,
      Model,
      OfferType,
      PowerHpFrom,
      PowerHpTo,
      Section1Id,
      Section2Id,
      Section3Id,
      SellerTypeId,
      TransmissionTypeId,
      Version,
      WithWarranty
    })

    /**
     * @type {Array}
     */
    this._arrBodyType = arrBodyType

    /**
     * @type {String}
     */
    this._FuelTypeId = FuelTypeId

    /**
     * @type {String}
     */
    this._MaxKms = MaxKms

    /**
     * @type {String}
     */
    this._MinKms = MinKms

    /**
     * @type {String}
     */
    this._ModelId = ModelId

    /**
     * @type {String}
     */
    this._MakeId = MakeId

    /**
     * @type {String}
     */
    this._MaxPrice = MaxPrice

    /**
     * @type {String}
     */
    this._ProvinceId = ProvinceId

    /**
     * @type {String}
     */
    this._MaxYear = MaxYear

    /**
     * @type {String}
     */
    this._MinYear = MinYear

    /**
     * @type {String}
     */
    this._KeyWords = KeyWords

    /**
     * @type {Number}
     */
    this._ContractId = ContractId

    /**
     * @type {Boolean}
     */
    this._Financed = Financed

    /**
     * @type {String}
     */
    this._MinPrice = MinPrice

    /**
     * @type {String}
     */
    this._Model = Model

    /**
     * @type {Number}
     */
    this._OfferType = OfferType

    /**
     * @type {String}
     */
    this._PowerHpFrom = PowerHpFrom

    /**
     * @type {Number}
     */
    this._PowerHpTo = PowerHpTo

    /**
     * @type {String}
     */
    this._Section1Id = Section1Id

    /**
     * @type {Number}
     */
    this._Section2Id = Section2Id

    /**
     * @type {Number}
     */
    this._Section3Id = Section3Id

    /**
     * @type {String}
     */
    this._SellerTypeId = SellerTypeId

    /**
     * @type {String}
     */
    this._TransmissionTypeId = TransmissionTypeId

    /**
     * @type {String}
     */
    this._Version = Version

    /**
     * @type {Boolean}
     */
    this._WithWarranty = WithWarranty
  }

  map = () => ({
    bodyTypes: this._arrBodyType && this._arrBodyType.map(Number),
    fuelType: this._FuelTypeId && Number(this._FuelTypeId),
    kmsMax: this._MaxKms && Number(this._MaxKms),
    kmsMin: this._MinKms && Number(this._MinKms),
    modelLiteral: this._Model,
    model: this._ModelId && Number(this._ModelId),
    brand: this._MakeId && Number(this._MakeId),
    priceMax: this._MaxPrice && Number(this._MaxPrice),
    priceMin: this._MinPrice && Number(this._MinPrice),
    province: this._ProvinceId && Number(this._ProvinceId),
    yearMax: this._MaxYear && Number(this._MaxYear),
    yearMin: this._MinYear && Number(this._MinYear),
    keywords: this._KeyWords,
    contractId: this._ContractId,
    financed: this._Financed,
    offerType: this._OfferType,
    minPowerHp: this._PowerHpFrom && Number(this._PowerHpFrom),
    maxPowerHp: this._PowerHpTo,
    section1Id: this._Section1Id && Number(this._Section1Id),
    section2Id: this._Section2Id,
    section3Id: this._Section3Id,
    sellerTypeId: this._SellerTypeId && Number(this._SellerTypeId),
    transmissionTypeId: this._TransmissionTypeId && Number(this._TransmissionTypeId),
    version: this._Version,
    withWarranty: this._WithWarranty
  })
}
